import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'teaser-journey-date-select';
const BLOCK_ID = 'teaser-journey-date-select';
const PLACEHOLDER_LABEL = 'Reisetermin wählen';


export default function journeyDateSelect(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        model: {
            defaults: {
                tagName: 'div',
                name: 'Journey Date Select',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-teaser-journey-date-select',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Reisetermin',
        category: blockCategories.teaser,
        media: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" d="M7 10h5v5H7zm12-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-teaser-journey-date-select',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
